import HalfMoon from '@assets/icons/half-moon.svg'
import { Icon } from './Icon'

export const HalfMoonIcon = Icon(HalfMoon)
